module.exports = __webpack_public_path__ + "img/location-not-found.9bcf6561.png";